import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiService } from './api.service';

export interface EquipmentStructureImportResult {
  plantsCreated: number;
  plantsUpdated: number;
  plantsDeleted: number;
  plantsSkippedDeletion: number;
  plannerGroupsCreated: number;
  plannerGroupsUpdated: number;
  plannerGroupsDeleted: number;
  plannerGroupsSkippedDeletion: number;
  workCentersCreated: number;
  workCentersUpdated: number;
  workCentersDeleted: number;
  workCentersSkippedDeletion: number;
  functionalLocationsCreated: number;
  functionalLocationsUpdated: number;
  functionalLocationsDeleted: number;
  functionalLocationsSkippedDeletion: number;
  errors: string[];
}

@Injectable({
  providedIn: 'root',
})
export class EquipmentStructureService {
  constructor(private apiService: ApiService) {}

  public importFromExcel(
    file: File,
  ): Observable<EquipmentStructureImportResult> {
    const formData = new FormData();
    formData.append('file', file);
    return this.apiService.postFormData<EquipmentStructureImportResult>(
      '/EquipmentStructure/import/',
      formData,
      true,
    );
  }
}
